'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/personalization'));
    processInclude(require('./product/giftPackage'));
    processInclude(require('wishlist/product/wishlist'));
    processInclude(require('./product/pdpInstoreInventory'));
    processInclude(require('./product/productDetail'));
    processInclude(require('./product/detail'));
    processInclude(require('./product/zoom'));
    processInclude(require('./product/images360'));
    processInclude(require('./product/bigVolumeproduct'));
    processInclude(require('./quantityButtonPdp'));
    processInclude(require('./product/clickAndCollectProduct'));
    processInclude(require('./product/paymentsPromotions'));
});
